var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Icon',{class:[
    'loader',
    !!_vm.state && [("loader--state--" + _vm.state)]
  ].filter(Boolean),attrs:{"type":"loader","size":_vm.iconSize}})}
var staticRenderFns = []

export { render, staticRenderFns }